import React from "react";
import styles from './styles/App.module.css';
import Homepage from "./homepage/Homepage";
import { Helmet } from "react-helmet";

export default function App() {
  return (
    <main className={styles.main}>
      <Helmet>
        <title>xeniapps | Freelance React Native & Full Stack Developer - Marco Zak Ciuffini</title>
        <meta name="description" content="Freelance full stack developer based in Birmingham, UK, specialising in React Native. Available for remote work. React, TypeScript, Next.js, Laravel." />
        <meta name="keywords" content="react native developer, freelance developer, full stack developer, react developer, mobile app developer, birmingham developer, remote developer, typescript developer, javascript developer, laravel developer, uk freelance developer" />
        <link rel="canonical" href="https://www.xeniapps.com" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.xeniapps.com" />
        <meta property="og:title" content="xeniapps | Freelance React Native & Full Stack Developer - Marco Zak Ciuffini" />
        <meta property="og:description" content="Freelance full stack developer based in Birmingham, UK, specialising in React Native. Available for remote work. React, TypeScript, Next.js, Laravel." />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="xeniapps | Freelance React Native & Full Stack Developer - Marco Zak Ciuffini" />
        <meta name="twitter:description" content="Freelance full stack developer based in Birmingham, UK, specialising in React Native. Available for remote work." />
      </Helmet>
      <Homepage />
    </main>
  );
}
